var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-panel',{attrs:{"title":"Attribution"}},[_c('v-section-text',{attrs:{"expanded":""}}),_c('v-section',{attrs:{"name":"Color"}},[_c('v-action-color',{attrs:{"type":"color"}})],1),_c('v-section-block')],1)}
var staticRenderFns = []

export { render, staticRenderFns }